import { useState, lazy, Suspense } from 'react';
import { Check, Copy } from 'lucide-react';

const ShikiHighlighter = lazy(() =>
  import('react-shiki').then(m => ({ default: m.ShikiHighlighter }))
);

interface CodeBlockProps {
  children?: React.ReactNode;
  className?: string;
}

export function CodeBlock({ children, className }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);
  const code = typeof children === 'string' ? children : String(children ?? '');
  const match = /language-(\w+)/.exec(className || '');
  const language = match?.[1] ?? 'text';

  const handleCopy = async () => {
    await navigator.clipboard.writeText(code.trim());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative group my-1">
      <button
        onClick={handleCopy}
        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded bg-background/80 hover:bg-muted border"
        title="Copy code"
        data-testid="button-copy-code"
      >
        {copied ? <Check className="h-3 w-3 text-green-500" /> : <Copy className="h-3 w-3 text-muted-foreground" />}
      </button>
      <Suspense fallback={<pre className="text-xs bg-muted/50 rounded p-2 overflow-x-auto">{code}</pre>}>
        <ShikiHighlighter language={language} theme="github-dark-dimmed">
          {code.trim()}
        </ShikiHighlighter>
      </Suspense>
    </div>
  );
}
